import {
  ArticleSearchConditionInput,
  FilterCondition,
} from '@/features/analyze/types';
import { removeEmptyValues } from '@/utils/removeEmptyValues';

type SavedArticleFilterCondition = {
  query: string | null;
  publishedStartDate: string | null;
  publishedEndDate: string | null;
  themes: unknown;
  countries: unknown;
  countryTags: unknown;
  organizations: unknown;
  organizationTypes: unknown;
  topicTags: unknown;
};

export const convertSavedFilterConditionToFilterCondition = (
  savedFilterCondition: SavedArticleFilterCondition
): FilterCondition => {
  const result = {
    query: savedFilterCondition.query || undefined,
    publishedStartAt: savedFilterCondition.publishedStartDate
      ? new Date(savedFilterCondition.publishedStartDate)
      : undefined,
    publishedEndAt: savedFilterCondition.publishedEndDate
      ? new Date(savedFilterCondition.publishedEndDate)
      : undefined,
    themes:
      savedFilterCondition.themes as ArticleSearchConditionInput['themes'],
    countries:
      savedFilterCondition.countries as ArticleSearchConditionInput['countries'],
    countryTags:
      savedFilterCondition.countryTags as ArticleSearchConditionInput['countryTags'],
    organizations:
      savedFilterCondition.organizations as ArticleSearchConditionInput['organizations'],
    organizationTypes:
      savedFilterCondition.organizationTypes as ArticleSearchConditionInput['organizationTypes'],
    topicTags:
      savedFilterCondition.topicTags as ArticleSearchConditionInput['topicTags'],
  };

  return removeEmptyValues(result);
};
